import { useEffect, useRef } from 'react';
import { HANDLE_MESSAGES_REQUEST } from '../utils';

export const useAutoDeleteInlineAttachments = ({
  draft,
  message,
  ticket,
  subject,
  editor,
  attachments,
  inlineAttachments,
  isLoading,
  mutateTicket,
  mutate,
  setEditorHasChanged,
  setIsLoadingSave,
  setAttachments,
  setInlineAttachments,
}) => {
  const isProcessingRef = useRef(false);

  useEffect(() => {
    if (isLoading || !editor || !draft?._id || isProcessingRef.current) return;
    if (
      attachments?.filter((att) => att.link !== 'pandora/logo-hoortrade.jpg')
        ?.length === inlineAttachments?.length
    )
      return;

    isProcessingRef.current = true;

    try {
      // Supprimer les pièces jointes inline
      if (inlineAttachments?.length < attachments?.length) {
        const attachementToDelete = attachments.filter((att) => {
          if (att.isAtt) return false;
          if (att.link === 'pandora/logo-hoortrade.jpg') return false;
          return !inlineAttachments.some((inlineAtt) =>
            att.link?.includes(inlineAtt.alt)
          );
        });

        if (attachementToDelete?.length > 0) {
          // // Mise à jour immédiate des états
          // attachementToDelete.forEach((att) => {
          //   setAttachments((prev) => prev.filter((a) => a.link !== att.link));
          //   setInlineAttachments((prev) =>
          //     prev.filter((a) => a.alt !== att.alt)
          //   );
          // });

          // Suppression des pièces jointes
          Promise.all(
            attachementToDelete.map(async (att) => {
              await HANDLE_MESSAGES_REQUEST.deleteAttachment({
                draftId: draft?._id,
                attachementToDelete: att,
                mutateTicket,
                mutate,
                setIsLoadingSend: () => {},
                setIsLoadingSave,
              });
            })
          )
            .then(() => {
              console.log('mutateTicket useAutoDeleteInlineAttachments');
              // mutateTicket();
              // mutate();
              setEditorHasChanged(false);
            })
            .catch((error) => {
              console.error('Error deleting attachments:', error);
              setIsLoadingSave(false);
              setEditorHasChanged(false);
            })
            .finally(() => {
              isProcessingRef.current = false;
            });
        } else {
          isProcessingRef.current = false;
        }
      } else {
        isProcessingRef.current = false;
      }
    } catch (error) {
      console.error('AutoSave draft error:', error);
      setIsLoadingSave(false);
      setEditorHasChanged(false);
      isProcessingRef.current = false;
    }

    return () => {
      isProcessingRef.current = false;
    };
  }, [
    message,
    ticket,
    subject,
    editor,
    attachments,
    inlineAttachments,
    isLoading,
    draft?._id,
    mutateTicket,
    mutate,
    setEditorHasChanged,
    setIsLoadingSave,
    setAttachments,
    setInlineAttachments,
  ]);
};
